import React, { forwardRef } from 'react';
import './AboutSection.scss';
import Container from 'reactor/components/Grid/ContainerWithWidth';
import Heading from './../../components/heading';

const AboutSection =  forwardRef((props, ref) => {
    
    return (
        <div id="about__section" ref={ref} >
            <Container>
                <Heading title="عن رواد"
                    subtitle="شركة رواد الاستضافة لتقنية المعلومات، مؤسسة سعودية رسمية تحمل سجل تجاري رقم (3350031328) إنطلقت رسمياً في عام (1433هـ - 2012م)، متخصصون في تقديم خدمات وحلول الويب المتكاملة، حيث تنوعت خدماتنا بين تصميم المواقع الإلكترونية، وتطبيقات الجوال، والتسويق الالكتروني، وتصميم الهويات التجارية. نجحنا فى كسب ثقة أكثر من 10 آلاف عميل فى السعودية لأكثر من 12 عام تميزنا فيها في صناعة الويب، وزيادة الوعي بتقنيات الويب في العالم العربي. نحن نؤمن بإنشاء المشاريع الاحترافية وقدرة فريقنا على الانتقال بأعمالنا إلى مستوى الريادة والتألق دائمًا."
                />
            </Container>
        </div>
    )
});

export default AboutSection;